












































































































































































































import Vue from "vue";
import { ComboBox } from "@progress/kendo-vue-dropdowns";
import createPagerText from "@/utils/pagerText";


interface Data{
    item: any;
    opened: boolean;
    currentPageSize: number;
    currentPageNumber: number;
    filter: string;
    firstPageNumberButtonVisible: boolean;
    firstPageNumberButtonValue: number;
    secondPageNumberButtonVisible: boolean;
    secondPageNumberButtonValue: number;
    thirdPageNumberButtonVisible: boolean;
    thirdPageNumberButtonValue: number;
    fourthPageNumberButtonVisible: boolean;
    fourthPageNumberButtonValue: number;
    fifthPageNumberButtonVisible: boolean;
    fifthPageNumberButtonValue: number;
    localItems: any[];
    isSelecting: boolean;
    selectOnMouseUp: boolean;
    lastValidItem: any;
}

interface Method{
    searchClick(item: object): void;
    resolveTypedItem(candidate: any): any;
    resolveTypedText(text: string): any;
    inputEl(): HTMLInputElement | null;
    emitSelection(item: any): void;
    searchChanged(event: any): void;
    setCurrentPageNumber(pageNumber: number): void;
    setCurrentPageSize(pageSize: number): void;
    decrementPageNumber(): void;
    incrementPageNumber(): void;
    onComboOpen(): void;
    onComboClose(): void;
    setPageNumbers(): void;
    onKeyDown(e: any): void;
    onInputFocus(): void;
    onInputMouseUp(e: any): void;
}

interface Computed{
    footerText: string;
    maxPageNumber: number;
    displayedItems: object[];
}
interface Props {
    columns: string[];
    fields: string[];
    items: object[];
    textField: string;
    selectedElement: string;
    disabled: boolean;
    /** Szerveroldali keresés: a gépelt szöveg 'search' eventként megy ki, a lista nem szűr helyben */
    remote: boolean;
}

export default Vue.extend<Data, Method, Computed, Props>({
    components: 
    { 
        ComboBox 
    },
    data(){
        return{
            item: null,
            opened: false,
            currentPageSize: 10,
            currentPageNumber: 1,
            filter: "",
            localItems: [],
            selectOnMouseUp: false,
            lastValidItem: null,
            firstPageNumberButtonVisible: true,
            firstPageNumberButtonValue: 1,
            secondPageNumberButtonVisible: true,
            secondPageNumberButtonValue: 2,
            thirdPageNumberButtonVisible: true,
            thirdPageNumberButtonValue: 3,
            fourthPageNumberButtonVisible: true,
            fourthPageNumberButtonValue: 4,
            fifthPageNumberButtonVisible: true,
            fifthPageNumberButtonValue: 5,
            isSelecting: false,
        }
    },
    methods:{
        async searchClick(item: object ) {
            this.isSelecting = true;
            this.item = item;
            this.emitSelection(item);
            this.$nextTick(() => {
                this.isSelecting = false;
            });
        },
        // Csak a listából származó (teljes) elemet adunk ki a szülőnek. A Kendo ComboBox
        // allow-custom módban a listában NEM szereplő gépelt szövegből csonk objektumot csinál
        // ({ [textField]: szöveg } — a többi mező, pl. id/name, hiányzik), üres szövegből null-t;
        // ezek Enter-re kiadva a szülő modelljébe undefined-et írtak (csendes adatvesztés).
        resolveTypedItem(candidate: any): any {
            if (!candidate) return null;
            const items = (this.$props.items ?? []) as any[];
            if (items.includes(candidate)) return candidate;
            return this.resolveTypedText(String(candidate[this.textField] ?? ''));
        },
        // A begépelt kód pontos (kis/nagybetű-független) egyezése a lista egy elemével → a teljes elem
        resolveTypedText(text: string): any {
            const q = String(text ?? '').trim().toLowerCase();
            if (!q || q === '-') return null;
            const items = (this.$props.items ?? []) as any[];
            return items.find((x) => String(x?.[this.textField] ?? '').trim().toLowerCase() === q) ?? null;
        },
        inputEl(): HTMLInputElement | null {
            return ((this.$refs.combo as any)?.$el?.querySelector('input') as HTMLInputElement) ?? null;
        },
        emitSelection(item: any) {
            this.lastValidItem = item;
            this.$emit("update:selectedElement", item);
            this.$emit('change', item);
        },
        searchChanged(event){
            if (this.isSelecting)
                return;
            this.filter = event.filter.value;
            // Szerveroldali keresés (remote): a szűrést nem itt végezzük, hanem a szülő kapja
            // meg a keresőszót ('search' event) és a találatokat az items propban adja vissza —
            // nagy törzseknél (pl. ~250 ezer cikk) a kliens-oldali lista nem járható.
            if (this.remote) {
                this.$emit('search', (this.filter ?? '').trim());
                this.localItems = this.$props.items;
                this.currentPageNumber = 1;
                this.setPageNumbers();
                return;
            }
            const q = this.filter.trim().toLowerCase();
            if (q !== "") {
                // A megjelenített mezők BÁRMELYIKÉRE illesztünk (nem csak a textField-re),
                // hogy a felhasználó arra kereshessen, amit a sorban lát (pl. megnevezés, rendszám).
                this.localItems = this.$props.items.filter((x: any) =>
                    this.fields.some((f) => (x[f] ?? "").toString().toLowerCase().includes(q)) ||
                    (x[this.textField] ?? "").toString().toLowerCase().includes(q)
                );
            } else {
                this.localItems = this.$props.items;
            }
            // Szűrés után az 1. oldalra állunk, különben a slice tartományon kívülre eshet.
            this.currentPageNumber = 1;
            this.setPageNumbers();
        },
        setCurrentPageNumber(pageNumber) {
            if (this.currentPageNumber == pageNumber) return;

            this.currentPageNumber = pageNumber;
        },
        setCurrentPageSize(pageSize) {
            if (this.currentPageSize == pageSize) return;

            this.currentPageSize = pageSize;
        },
        onComboOpen() {
            this.opened = true;
            // A szülő ezen töltheti be a kezdő listát (pl. remote módban, gépelés nélkül)
            this.$emit('open');
            this.localItems = this.$props.items;
            this.currentPageNumber = 1;
            this.setPageNumbers();
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    const popupEl = document.querySelector<HTMLElement>('.k-animation-container');
                    const combo = this.$refs.combo as any;
                    if (!popupEl || !combo) return;

                    const listRect = popupEl.getBoundingClientRect();
                    const inputRect = combo.$refs.baseWrapper.getBoundingClientRect();
                    const screenWidth = window.innerWidth;
                    const screenHeight = window.innerHeight;

                    let translateX = 0;
                    let translateY = 0;

                    // Vízszintes: ha jobbra kilógna, balra húzzuk.
                    if (listRect.right > screenWidth) {
                        translateX = -(listRect.width - inputRect.width);
                    }

                    // Függőleges: ha lefelé nyitva a viewport aljából kilógna (azaz növelné az
                    // oldalt), ÉS felfelé van elég hely, akkor az input fölé toljuk -> felfelé nyílik.
                    if (listRect.bottom > screenHeight && inputRect.top > listRect.height) {
                        translateY = -(listRect.height + inputRect.height);
                    }

                    // Mindig beállítjuk (akár 0,0), hogy egy korábbi nyitás eltolása ne ragadjon ott.
                    popupEl.style.transform = `translate(${translateX}px, ${translateY}px)`;
                });
            });
        },
        onComboClose(){
            this.opened = false;
        },
        incrementPageNumber(){
            const maxPageNumber = Math.ceil(
                this.localItems.length / this.currentPageSize
            );
            if (this.currentPageNumber == maxPageNumber) return;

            this.currentPageNumber++;
        },
        decrementPageNumber(){
            if (this.currentPageNumber == 1) return;

            this.currentPageNumber--;
        },
        setPageNumbers() {
            if (this.currentPageNumber == 0) return;

            const maxPageNumber = Math.ceil(
                this.localItems.length / this.currentPageSize
            );
            if (maxPageNumber <= 5) {
                this.firstPageNumberButtonVisible = false;
                this.secondPageNumberButtonVisible = false;
                this.thirdPageNumberButtonVisible = false;
                this.fourthPageNumberButtonVisible = false;
                this.fifthPageNumberButtonVisible = false;

            if (maxPageNumber >= 1) {
            this.firstPageNumberButtonVisible = true;
            this.firstPageNumberButtonValue = 1;
            }

            if (maxPageNumber >= 2) {
            this.secondPageNumberButtonVisible = true;
            this.secondPageNumberButtonValue = 2;
            }

            if (maxPageNumber >= 3) {
            this.thirdPageNumberButtonVisible = true;
            this.thirdPageNumberButtonValue = 3;
            }

            if (maxPageNumber >= 4) {
            this.fourthPageNumberButtonVisible = true;
            this.fourthPageNumberButtonValue = 4;
            }

            if (maxPageNumber == 5) {
            this.fifthPageNumberButtonVisible = true;
            this.fifthPageNumberButtonValue = 5;
            }
            } else {
                this.firstPageNumberButtonVisible = true;
                this.secondPageNumberButtonVisible = true;
                this.thirdPageNumberButtonVisible = true;
                this.fourthPageNumberButtonVisible = true;
                this.fifthPageNumberButtonVisible = true;

            if (maxPageNumber - this.currentPageNumber < 5) {
            this.firstPageNumberButtonValue = maxPageNumber - 4;
            this.secondPageNumberButtonValue = maxPageNumber - 3;
            this.thirdPageNumberButtonValue = maxPageNumber - 2;
            this.fourthPageNumberButtonValue = maxPageNumber - 1;
            this.fifthPageNumberButtonValue = maxPageNumber;
            } else {
            if (this.currentPageNumber < 5) {
                this.firstPageNumberButtonValue = 1;
                this.secondPageNumberButtonValue = 2;
                this.thirdPageNumberButtonValue = 3;
                this.fourthPageNumberButtonValue = 4;
                this.fifthPageNumberButtonValue = 5;
            } else {
                this.firstPageNumberButtonValue = this.currentPageNumber - 2;
                this.secondPageNumberButtonValue = this.currentPageNumber - 1;
                this.thirdPageNumberButtonValue = this.currentPageNumber;
                this.fourthPageNumberButtonValue = this.currentPageNumber + 1;
                this.fifthPageNumberButtonValue = this.currentPageNumber + 2;
                }
            }
        }
        },
        onKeyDown(e){
            if (e.key !== 'Enter') return;
            // A ténylegesen begépelt szövegből indulunk ki (a Kendo v-modellje Enter-kor még a
            // korábbi értéken is állhat), másodlagosan a v-model elemből
            const input = this.inputEl();
            const typed = input ? String(input.value ?? '') : '';
            const resolved = this.resolveTypedText(typed) ?? this.resolveTypedItem(this.item);
            if (resolved) {
                this.item = resolved;
                this.emitSelection(resolved);
                return;
            }
            // Nem létező kód vagy üres mező: nem adunk ki csonk objektumot, a mező az utolsó
            // érvényes kiválasztásra (ennek híján a szülő aktuális értékére) áll vissza —
            // a K2D DataWindow is elutasítja a listában nem szereplő kódot.
            const fallback = this.lastValidItem
                ?? { [this.textField]: this.$props.selectedElement ? this.$props.selectedElement : "-" };
            this.item = fallback;
            if (input) {
                // A látható szöveg is álljon vissza (a selectedElement watcher mintája)
                input.value = String(fallback[this.textField] ?? '');
                input.dispatchEvent(new Event('input'));
            }
            this.$emit('invalid', typed.trim());
        },
        // Fókuszra a teljes tartalom kijelölése: az első leütés így LECSERÉLI a régi értéket
        // (a "-" placeholdert és a korábbi kiválasztást is) — enélkül a gépelés hozzáfűz
        // ("-9211") és a keresés találat nélkül marad.
        onInputFocus(){
            const input = (this.$refs.combo as any)?.$el?.querySelector('input');
            if (!input) return;
            this.selectOnMouseUp = true;
            input.select();
        },
        // A fókuszt adó kattintás mouseup-ja alapból szétszedné a kijelölést — egyszer elnyeljük.
        // A második kattintás már normál kurzor-pozicionálás, így a szövegen belüli szerkesztés megmarad.
        onInputMouseUp(e){
            if (this.selectOnMouseUp) {
                e.preventDefault();
                this.selectOnMouseUp = false;
            }
        }
    },
    props:{
        columns:{ type: Array as () => string[], default: () => [] },
        items: {type: Array as () => object[], default: () => []},
        fields: { type: Array as () => string[], default: () => [] },
        textField: { type: String, default: '' },
        selectedElement: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        /** Szerveroldali keresés: a gépelt szöveget 'search' eventként adja ki, a listát nem szűri helyben */
        remote: { type: Boolean, default: false }
    },
    computed:{
        footerText() {
            return createPagerText(
                this.localItems.length,
                this.currentPageNumber,
                this.currentPageSize,
            );
        },
        maxPageNumber() {
            return Math.ceil(this.localItems.length / this.currentPageSize);
        },
        displayedItems() {
            return this.localItems.slice((this.currentPageNumber*this.currentPageSize)-this.currentPageSize,this.currentPageNumber*this.currentPageSize);
        },
    },
    mounted(){  
        this.item = {[this.textField]: this.$props.selectedElement != 'undefined' ? this.$props.selectedElement : "-"}
        this.setPageNumbers()
        const combo = this.$refs.combo;
        const input = (combo as any).$el.querySelector('input');
        if (input) {
            input.addEventListener('keydown', this.onKeyDown);
            input.addEventListener('focus', this.onInputFocus);
            input.addEventListener('mouseup', this.onInputMouseUp);
        }
    },
    beforeDestroy(){
        // A mounted-ban kézzel felvett listenerek leszedése, hogy ne szivárogjanak.
        const combo = this.$refs.combo as any;
        const input = combo?.$el?.querySelector('input');
        if (input) {
            input.removeEventListener('keydown', this.onKeyDown);
            input.removeEventListener('focus', this.onInputFocus);
            input.removeEventListener('mouseup', this.onInputMouseUp);
        }
    },
    watch:{
        currentPageNumber(){
            this.setPageNumbers();
        },
        selectedElement(newVal) {
            const combo = this.$refs.combo as any;
            if(newVal != combo.input.value){
                combo.input.value = newVal;
                combo.input.dispatchEvent(new Event("input"));
                this.opened = false;
            }
        },
        items: {
            immediate: true,
            handler(val) {
                // Sekély másolat elég: a localItems-et csak szűrjük/szeleteljük, sosem mutáljuk helyben.
                this.localItems = Array.isArray(val) ? [...val] : [];
                this.currentPageNumber = 1;
                this.setPageNumbers();
            }
        }
    }
});
